// "Guardar em": celular, Google Drive ou OneDrive (Scanner PDF e PDF Edit).
import { useEffect, useState } from 'react';
import { Alert, Platform, Pressable, Text, View } from 'react-native';
import { useRouter } from 'expo-router';
import { Chip } from './ui';
import { C } from './theme';
import type { DestinoScan } from '../store/types';
import { NOME, atualizarNuvem, contaDe, useNuvem } from '../lib/nuvem';
import { NO_NAVEGADOR, escolherPasta, pastaAtual } from '../lib/scanArquivos';
import { t } from '../lib/i18n';

export function GuardarEm({ valor, onMudar, cor, titulo, dicaNuvem, dicaPasta }: {
  valor: DestinoScan; onMudar: (g: DestinoScan) => void; cor: string; titulo: string;
  dicaNuvem: (nome: string) => string; dicaPasta: (pasta: string) => string;
}) {
  useNuvem();
  const router = useRouter();
  const [pasta, setPasta] = useState<string | null>(null);
  useEffect(() => { atualizarNuvem().catch(() => {}); }, []);
  useEffect(() => { pastaAtual().then(setPasta).catch(() => {}); }, [valor]);
  const irAjustes = () => router.navigate({ pathname: '/ajustes', params: { sec: 'nuvem' } } as any);
  async function escolher(g: DestinoScan) {
    if (g !== 'aparelho' && !contaDe(g)) {
      Alert.alert(t('Conectar o {nome}', { nome: NOME[g] }), t('Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.', { nome: NOME[g] }), [
        { text: t('Cancelar'), style: 'cancel' }, { text: t('Abrir Ajustes'), onPress: irAjustes }]);
      return;
    }
    onMudar(g);
    if (g === 'aparelho' && Platform.OS === 'android' && !NO_NAVEGADOR && !pasta) setPasta(await escolherPasta().catch(() => null));
  }
  const dica = valor !== 'aparelho' ? dicaNuvem(NOME[valor])
    : NO_NAVEGADOR ? t('No navegador, o PDF é baixado para o computador.')
    : Platform.OS === 'ios' ? t('O app abre "Salvar em Arquivos" para você escolher a pasta (pode ser o iCloud Drive).')
    : pasta ? dicaPasta(pasta) : t('Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.');
  return (
    <View style={{ backgroundColor: C.card, borderRadius: 16, padding: 12, gap: 8 }}>
      <Text style={{ color: C.text, fontWeight: '700' }}>💾 {titulo}</Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
        {(['aparelho', 'google', 'microsoft'] as DestinoScan[]).map(g => (
          <Chip key={g} small cor={cor} on={valor === g} onPress={() => escolher(g)}
            label={g === 'aparelho' ? '📱 ' + (NO_NAVEGADOR ? t('Computador') : t('Celular')) : `${g === 'google' ? '🟢' : '🔵'} ${NOME[g]}${contaDe(g) ? '' : ' ↗'}`} />
        ))}
      </View>
      <Text style={{ color: C.sub, fontSize: 12 }}>{dica}</Text>
      {valor === 'aparelho' && Platform.OS === 'android' && !NO_NAVEGADOR && (
        <Pressable onPress={async () => setPasta((await escolherPasta().catch(() => null)) ?? pasta)}>
          <Text style={{ color: cor, fontSize: 13, fontWeight: '700' }}>📂 {pasta ? t('Trocar a pasta') : t('Escolher a pasta')}</Text>
        </Pressable>
      )}
    </View>
  );
}
